<template>
<div class="chapter">
<div class="inner_page">
<p class="image5c"><a id="page_13"><img alt="Image" height="328" src="images/7.jpg" width="300"/></a></p><a id="page_13">
<p class="noindent">Debt stops dreams.</p>
</a><p class="indent"><a id="page_13">A typical credit card purchase ends up costing 112 percent more than if you’d used cash. A $1,000 charge on an average credit card will take almost twenty-two years to pay and will cost more than $2,300 in interest if you make only minimum payments.<sup></sup></a><a id="ch0fn1"></a><span class="nounder" href="#/xhtml/notes#ich0fn1" title="Link target outside of Sample">1</span> So that $1,000 purchase really costs you $3,300.</p>
<p class="indent">But what if instead of making the credit card companies rich, you invested in yourself? If you save $218 per month for twenty-five years, you would retire with $1,354,930.00!</p>
<p class="indent"> </p>
<div class="sidebar">
<p class="h4"><a id="page_14">How to use a credit card wisely</a></p><a id="page_14">
<p class="noindent">1. Try to pay off the balance every month.</p>
<p class="indent"> </p>
<p class="noindent">2. Only use the credit card for:</p>
<p class="indenthanginga">• business expenses for which you will be reimbursed. (Remember to pay the credit card charges when you receive reimbursement.)</p>
<p class="indenthanginga">• renting a car. (Most car rental companies accept only major credit cards for payment.)</p>
<p class="indenthanginga">• medical emergencies.</p>
<p class="indenthanginga">• auto repairs that affect your ability to drive the car.</p>
<p class="indenthanginga">• replacing broken major appliances if they are absolutely necessary (like water heater, stove, or refrigerator).</p>
<p class="noindent">3. DO NOT use your credit card to purchase:</p>
<p class="indenthanginga">• clothes.</p>
<p class="indenthanginga">• food, whether at restaurants or the grocery store.</p>
<p class="indenthanginga">• music.</p>
<p class="indenthanginga">• books.</p>
<p class="indenthanginga">• entertainment.</p>
<p class="indenthanginga">• haircuts.</p>
<p class="indenthanginga">• games—computer, video, or otherwise.</p>
<p class="indent"> </p>
<p class="noindentl1">Purchase these items with cash as you can afford them out of your income.</p>
</a></div><a id="page_14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch04.vue?4b657506